import "./EnterPassword.less";

import React, { Component } from "react";
import { translate } from "react-i18next";
import { Link } from "react-router-dom";
import $ from "jquery";
import queryString from "query-string";

import config from "../../../config";
import Password from "../../Password/Password";

class EnterPassword extends Component {	
	state = {
	};

	render() {
		const t = this.props.t;

		return (
			<div className="enter-password">
				<p className="header">{t("description")}</p>

				<form onSubmit={this.handleSubmitClick} noValidate>
					<Password onChange={this.handlePasswordChange} />
					{this.state.showError && <p className="error">{this.state.errorMessage}</p>}
					<button type="submit" className="primarybtn">
						{t("submitButton")}
					</button>
				</form>

				<div className="login-link-holder">
					<Link to="/login">{t("backToLogin")}</Link>
				</div>
			</div>
		);
	}

	handlePasswordChange = password => {
		this.setState({ password });
	};

	handleSubmitClick = e => {
		const t = this.props.t;

		e.preventDefault();

		if ((this.state.password || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('passwordRequired') });
			return;
		}
		
		this.setState({ showError: false, errorMessage: '' });		
		
		const currentQuery = queryString.parse(window.location.search);
		const returnUrl = currentQuery.returnUrl;

		$.post(`${config.identityServer.baseUrl}/Portal/ForgottenPasswordValidate`, {
			reference: currentQuery.reference,
			validate: currentQuery.validate,
			password: this.state.password,
			clientId: currentQuery.clientId || config.identityServer.clientId,
			culture: config.language + "-BE",
			returnUrl: returnUrl
		},
		result => {
			if (!result.success) {
				this.setState({ showError: true, errorMessage: t(result.errorCode) });
			}
			else {				
				const url = `${config.identityServer.baseUrl}/Portal/ForgottenPasswordConfirm`

				$($('<form method="POST" />').attr('action', url))
					.append($('<input type="hidden" name="reference">').val(currentQuery.reference))
					.append($('<input type="hidden" name="validate">').val(currentQuery.validate))
					.append($('<input type="hidden" name="password">').val(this.state.password))
					.append($('<input type="hidden" name="clientId">').val(currentQuery.clientId || config.identityServer.clientId))
					.append($('<input type="hidden" name="culture">').val(config.language + "-BE"))
					.append($('<input type="hidden" name="returnUrl">').val(currentQuery.returnUrl))
					.appendTo(document.body)
					.submit();
			}
        })
		.fail(() => {
			this.setState({ showError: true, errorMessage: t('unexpectedError') });
		});
	};
}

export default translate("enterPassword")(EnterPassword);



// WEBPACK FOOTER //
// ./src/components/ForgottenPassword/EnterPassword/EnterPassword.js